import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22ce1a33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product__info" }
const _hoisted_2 = { class: "product__info--header" }
const _hoisted_3 = { class: "header__rating" }
const _hoisted_4 = { class: "header__title" }
const _hoisted_5 = { class: "product__info--brand" }
const _hoisted_6 = { class: "product__info--description" }

import { toRefs } from 'vue';
import { RouteNames } from '@/router/names';
import { ICartItem } from '@/store/cart/_types';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartProductInfo',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: ICartItem;
};



const { id, title, brand, description, rating } = toRefs(props.item.product);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-star" }),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(rating)), 1 /* TEXT */),
      _createVNode(_component_router_link, {
        to: { name: _unref(RouteNames).product, params: { id: `${_unref(id)}` } }
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(title)), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"])
    ]),
    _createElementVNode("span", _hoisted_5, "Brand: " + _toDisplayString(_unref(brand)), 1 /* TEXT */),
    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(description)), 1 /* TEXT */)
  ]))
}
}

})